document.addEventListener('DOMContentLoaded', function () {
  // Only run if <main class="gh-main"> exists and is NOT a recipe page
  const main = document.querySelector('main.gh-main.about-page');
  if (!main) {
    return;
  }

  // Target the main article and content section
  const article = main.querySelector('article.gh-article');
  const contentSection = main.querySelector('section.gh-content');
  if (!article || !contentSection) return;

  contentSection.classList.add('newsletter-content-centered');
  contentSection.style.margin = '0 auto';
  contentSection.style.display = 'block';
  contentSection.style.padding = '0 1.5rem';

  const images = contentSection.querySelectorAll('img');
  images.forEach((img) => {
    img.style.display = 'block';
    img.style.margin = '2.5rem auto';
    img.style.maxWidth = '100%';
    img.style.width = 'auto';
  });
  // Also handle wide figures
  const figures = contentSection.querySelectorAll('figure');
  figures.forEach((fig) => {
    fig.style.display = 'block';
    fig.style.margin = '2.5rem auto';
    fig.style.maxWidth = '100%';
  });

  const header = article.querySelector('.gh-article-header');
  if (header && !header.classList.contains('newsletter-header-content')) {
    const split = document.createElement('div');
    split.className = 'newsletter-header-split';

    const featureImage = header.querySelector('picture.gh-article-image');
    const imageDiv = document.createElement('div');
    imageDiv.className = 'newsletter-header-image';
    if (featureImage) imageDiv.appendChild(featureImage);

    const contentDiv = document.createElement('div');
    contentDiv.className = 'newsletter-header-content';

    const metaTime = header.querySelector('time.gh-article-meta-date');
    if (metaTime) {
      contentDiv.appendChild(metaTime);
    }

    // Add date above the title group
    const dateDiv = document.createElement('div');
    dateDiv.className = 'gh-article-date text-brown-40 text-eyebrow text-center mb-2';
    // Use metaTime for the date if it exists
    let dateText = '';
    if (metaTime) {
      dateText = metaTime.textContent;
      // Remove the original <time> element to avoid duplicate
      if (metaTime.parentNode) {
        metaTime.parentNode.removeChild(metaTime);
      }
    } else {
      // Try to get date from meta, fallback to today
      const meta = header.querySelector('.gh-article-meta');
      if (meta && meta.dataset && meta.dataset.date) {
        dateText = meta.dataset.date;
      } else {
        // Format today's date as 'Feb 02, 2024'
        const today = new Date();
        dateText = today.toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
        });
      }
    }
    dateDiv.textContent = dateText;
    contentDiv.appendChild(dateDiv);
    const groupDiv = document.createElement('div');
    groupDiv.className = 'newsletter-header-title-group';

    const title = header.querySelector('.gh-article-title');
    const excerpt = header.querySelector('.gh-article-excerpt');
    if (title) groupDiv.appendChild(title);
    if (excerpt) groupDiv.appendChild(excerpt);
    contentDiv.appendChild(groupDiv);

    let byline = header.querySelector('.gh-article-byline');
    if (!byline) {
      byline = document.createElement('div');
      byline.className = 'gh-article-byline';
      byline.textContent = 'by ALISON ROMAN';
    }
    contentDiv.appendChild(byline);

    split.appendChild(imageDiv);
    split.appendChild(contentDiv);

    header.parentNode.replaceChild(split, header);
  }
});
